import React, { useState, useEffect } from "react";
import style from "../../style/AddDataBodyHashLink.module.scss";
import { HashLink } from "react-router-hash-link";
import styled from "styled-components";
import { useLayoutEffect } from "react";

const List = styled.div`
  display: none;
  cursor: pointer;
  @media (max-width: 1200px) {
    display: flex;
    justify-content: space-between;
    border: 1px solid #e0e0e0;
    padding: 10px;
    border-radius: 5px;
  }
`;

function AddDataBodyHashLink() {
  const [open, setOpen] = useState(true);
  function handleOpen() {
    if (window.innerWidth <= 1200) {
      setOpen(!open);
    } else {
      setOpen(true);
    }
  }

  useLayoutEffect(() => {
    window.addEventListener("resize", handleOpen);
    return () => {
      window.addEventListener("resize", handleOpen);
    };
  }, []);
  return (
    <>
      <List onClick={handleOpen}>
        <div>選單</div>
        <i className="fa-solid fa-bars"></i>
      </List>

      <div
        className={style.container}
        style={{ display: open ? "block" : "none" }}
      >
        <div className={style.information}>
          <div className={style.icon_box}>
            <i className={`fa-solid fa-rectangle-list ${style.icon}`}></i>
          </div>
          <HashLink
            scroll={(e) => e.scrollIntoView({ behavior: "smooth" })}
            to={"/ReferralAddData#one"}
            className={style.name}
          >
            轉介個案資訊
          </HashLink>
        </div>
        <div className={style.message}>
          <div className={style.icon_box}>
            <i className={`fa-solid fa-comment-medical ${style.icon}`}></i>
          </div>
          <HashLink
            scroll={(e) => e.scrollIntoView({ behavior: "smooth" })}
            to={"/ReferralAddData#two"}
            className={style.name}
          >
            病情留言板
          </HashLink>
        </div>
      </div>
    </>
  );
}

export default AddDataBodyHashLink;
